<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
import AOS from 'aos';
import {mapActions} from "vuex";

export default {
    name: 'App',
    mounted() {
        AOS.init({
            duration: 1000,
            once: true
        });
    },

    methods: {
        ...mapActions('localization', [
            'getCurrentLocale'
        ]),
    },

    created() {
        this.getCurrentLocale();
    }
}
</script>

<style scoped></style>
